import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { APPOINTMENTS, APPOINTMENT_STATUS, APPOINTMENT_DISPOSITIONS, REFERRAL } from '_constants';
import moment from 'moment';
import confirmedIcon from 'assets/images/confirmed.svg';
import rescheduleIcon from 'assets/images/reschedule.svg';
import cancelIcon from 'assets/images/cancel.svg';
import BasicModal from '../../../common/modals/BasicModal';
import infoIcon from 'assets/images/info-icon-blue.png';

const PendingAppointmentStatus = (props) => {
  PendingAppointmentStatus.propTypes = {
    updateAppointmentStatus: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    activeAppointment: PropTypes.object.isRequired
  };

  const confirmAppointment = async (props) => {
    await props.updateAppointmentStatus(APPOINTMENT_STATUS.CONFIRMED.id, APPOINTMENT_DISPOSITIONS.CONFIRMED_BY_AGENT_AND_CUSTOMER, REFERRAL.DEFAULT_CARD, 'Appointment Confirmed', 'Error on appointment confirm');
    if (moment() > moment(props.activeAppointment.startDate)) {
      props.history.push(`/appointmentdetails/${props.activeAppointment.id}`);
    }
  };

  const [show, setshow] = useState(false);

  const hideModal = () => {
    setshow(false);
  };

  const { startDate } = props.activeAppointment;

  return (
    <React.Fragment>
      {
        show &&
        <BasicModal
          show={show}
          hideModal={hideModal}
          onOk={() => confirmAppointment(props)}
          dialogClassName={'confirm-appt-status-info-modal'}
          showCloseButton
          OkButtonText={'YES'}
          CancelButtonText={'NO'}
          title={
            <div className='modal-title'>
              <img className='info-icon' src={infoIcon} />
              <h6 className='center-align p-7 confirm-appt-title'>{APPOINTMENTS.CONFIRMING_APPOINTMENT}</h6>
            </div>
          }>
          <div>You are confirming the appointment for {moment(startDate).format('MM/DD/YYYY hh:mm A')}.</div>
          <div>An email and text will be sent to {props.activeAppointment.contacts[0].firstName} {props.activeAppointment.contacts[0].lastName}.</div>
          <div className='modal-message-first-line'>{APPOINTMENTS.CONFIRMATION_TEXT}</div>
        </BasicModal>
      }
      <div>
        <div>
          { (moment() > moment(startDate))
            ? <div className='align-appt-status'>
              <h6 className='center-align p-7'>What is the appointment outcome?</h6>
              <div className='appt-status-label align-appt-label'>PAST DUE</div>
            </div>
            : <div>
              <h5 className='center-align p-7'>What is the appointment status for
                <div>{moment(startDate).format('MM/DD/YYYY hh:mm A')}?</div></h5>
            </div>
          }
        </div>
        <div className='d-flex justify-content-around'>
          <div>
            {
              (moment() > moment(startDate))
                ? <div className='text-center' onClick={() => { props.history.push(`/appointmentaction/complete/${props.activeAppointment.id}`); }}>
                  <div className='m-1' ><img src={confirmedIcon} /></div>
                  <div><small>Complete</small></div>
                </div>
                : <div className='text-center' onClick={() => setshow(true)}>
                  <div className='m-1' ><img src={confirmedIcon} /></div>
                  <div><small>Confirmed</small></div>
                </div>
            }
          </div>
          <div className='text-center' onClick={() => { props.history.push(`/appointmentaction/reschedule/${props.activeAppointment.id}`); }}>
            <div className='m-1' >
              <img src={rescheduleIcon} />
            </div>
            <div><small>Reschedule</small></div>
          </div>
          <div className='text-center' onClick={() => { props.history.push(`/appointmentaction/cancel/${props.activeAppointment.id}`); }}>
            <div className='m-1' >
              <img src={cancelIcon} />
            </div>
            <div><small>Cancel</small></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PendingAppointmentStatus;
